import classNames from "classnames";
import {Link, useLocation} from "react-router-dom";

import Divider from "components/Divider";
import NavigationTab from "components/NavigationTab";

// import {useHasUpcomingAppointment} from "liberty-core/api/react-query/appointment";
// import {useAuthenticatedUser} from "lib/auth";
import {mainNavLinks, secondaryNavLinks} from "lib/navLinks";
import {useCurrentPharmacy} from "lib/useCurrentPharmacy";

import styles from "./LeftNavigationBar.module.css";

type Props = {
  className?: string;
  fullName?: string;
};

export default function LeftNavigationBar(props: Props) {
  const [pharmacy] = useCurrentPharmacy();
  const currentPath = useLocation().pathname;
  // const [authenticatedUser] = useAuthenticatedUser();
  // const hasUpcoming = useHasUpcomingAppointment({enabled: !!authenticatedUser});
  return (
    <div className={classNames(styles.container, props.className)}>
      {props.fullName ? (
        <h2 className={styles.title}>{props.fullName}</h2>
      ) : null}
      <div className={styles.navigationBar}>
        {mainNavLinks(pharmacy?.appointmentsEnabled ?? false).map((navLink) => {
          return (
            <NavigationTab
              key={navLink.label}
              label={navLink.label}
              to={navLink.to}
              icon={navLink.icon(
                currentPath.startsWith(navLink.to),
                // hasUpcoming,
              )}
              selected={currentPath.startsWith(navLink.to)}
              disabled={!pharmacy?.name}
            />
          );
        })}
      </div>
      {secondaryNavLinks.length > 0 ? (
        <Divider className={styles.lineDivider} />
      ) : null}
      {secondaryNavLinks.map((navLink, index) => {
        return (
          <Link key={index} to={navLink.to} className={styles.secondaryLink}>
            {navLink.label}
          </Link>
        );
      })}
    </div>
  );
}
